// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"03cc1050","322":"e99035c0"}[chunkId] + ".chunk.css";
};